<script>
  import { preferences } from 'modules/preferences.js'

  export let mode = preferences.mode
  let container = undefined
  $: num = modes.length

  const modes = [
    { value: 'central', label: 'central' },
    { value: 'grid', label: 'grid' },
    { value: 'vertical', label: 'vertical' },
    { value: 'horizontal', label: 'horizontal' },
    { value: 'radial', label: 'radial' },
    { value: 'treemap', label: 'treemap' },
  ]

  import ButtonSummary from 'components/primer/ButtonSummary.svelte'
  import SelectMenuTitle from 'components/primer/SelectMenuTitle.svelte'
  import Octicon from 'components/primer/Octicon.svelte'

  let open = false

  const close = () => {
    open = false
  }
  const show = () => {
    open = true
  }
  const select = m => {
    mode = m
    close()
  }
  const focusSummary = () => {
    // we directly target the summary element in <ButtonSummmary>. Not ideal
    // since it's encapsulated
    container.querySelector(`summary`).focus()
  }
  const focusItem = i => {
    // nth-child uses 1-based numeration
    container
      .querySelector(`.SelectMenu-list .SelectMenu-item:nth-child(${i + 1})`)
      .focus()
  }

  const summaryArrowDown = event => {
    show()
  }
  const detailsToggled = event => {
    if (open) {
      focusItem(0)
    }
  }
  const itemKeydown = i => event => {
    if (['ArrowDown', 'ArrowUp', 'Escape'].includes(event.key)) {
      event.stopPropagation()
      event.preventDefault()
    }
    if (event.key === 'ArrowDown' && i < num - 1) {
      focusItem(i + 1)
    } else if (event.key === 'ArrowUp' && i > 0) {
      focusItem(i - 1)
    } else if (event.key === 'Escape') {
      close()
      focusSummary()
    }
  }
</script>

<style>
  .griddingIcon {
    background-repeat: no-repeat;
    background-position: left 50% top 50%;
    display: inline-block;
    background-size: 70%;
    height: 1.5em;
    width: 1.5em;
  }
</style>

<div class="modes" bind:this={container}>
  <details
    class="details-reset details-overlay select-menu"
    bind:open
    on:toggle={detailsToggled}>
    <ButtonSummary
      expanded={open}
      prefix=""
      title={mode}
      on:arrowdown={summaryArrowDown}>
      <span
        class="griddingIcon pl-5"
        style="background-image:
        url('https://projet.liris.cnrs.fr/mi2/oddata/icons/{mode}.svg');" />
    </ButtonSummary>
    <div class="SelectMenu">
      <div class="SelectMenu-modal">
        <SelectMenuTitle on:click={close}>Select a grid mode</SelectMenuTitle>
        <div class="SelectMenu-list">
          {#each modes as m, i}
            <button
              class="SelectMenu-item"
              role="menuitem"
              aria-checked={m.value === mode}
              on:click={() => select(m.value)}
              on:keydown={itemKeydown(i)}>
              <Octicon symbol="check" class="SelectMenu-icon" />
              <!-- TODO: replace by local SVG icons -->
              <span
                class="griddingIcon pl-5"
                style="background-image:
                url('https://projet.liris.cnrs.fr/mi2/oddata/icons/{m.label}.svg');" />
              {m.label}
            </button>
          {/each}
        </div>
      </div>
    </div>
  </details>
</div>
